import React, { Component } from "react";
import { Route } from "react-router-dom";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeftSidebar from "../../component/admin/LeftSidebar";
import TopHeader from "../../component/admin/TopHeader";
import "../../component/admin/MultipleReactQuillEditor";
import { MultipleReactQuillEditor } from "../../component/admin/MultipleReactQuillEditor";
import NewReachTextEditor from "./NewReachTextEditor";

const updateDepartment = (
  id,
  data,
  edit_department_image,
  edit_department_image_hover,
  edit_department_banner_image,
  selectedPackageId,
  selectedInvestigationId,
  descriptions
) => {
  let formdata = new FormData();
  formdata.append("edit_department_image", edit_department_image);
  formdata.append("edit_department_image_hover", edit_department_image_hover);
  formdata.append("edit_department_banner_image", edit_department_banner_image);
  formdata.append("packages", JSON.stringify(selectedPackageId));
  formdata.append("investigations", JSON.stringify(selectedInvestigationId));
  formdata.append("description_list", JSON.stringify(descriptions));
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.post(
      "/department/updatedepartment/" + id,
      formdata,
      {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": `multipart/form-data; boundary=${formdata._boundary}`,
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
        params: {
          ...data,
        },
      }
    );
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getSingleDepartmentData = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/department/getsingledepartment/" + id, {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getAllPackages = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/packages/getall", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getInvestigations = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/investigations", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res)).catch((err) => reject(err));
  });
};
const getAssignedDoctors = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request(`/doctor_dept_rel?department_id=${id}`, {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res)).catch((err) => reject(err));
  });
};
const alertStyle = {
  color: "red",
};
class EditDepartment extends Component {
  state = {
    fields: {},
    errors: {},
    department_id: "",
    edit_department_name: "",
    edit_department_id: "",
    edit_department_image: "",
    edit_department_image_hover: "",
    edit_department_banner_image: "",
    descriptions: [
      { value: "", visibility: 1, key: this.generateRandomText() },
    ],
    packages: [],
    selectedPackageId: [],
    packageSearch: "",
    assignedDoctors: [],
    investigations: [],
    selectedInvestigationId: [],
    investigationSearch: "",
    editingSlNoIndex: null, // Index of the doctor currently being edited
    updatedSlNo: "", // Updated sl_no value
  };
  validateForm() {
    //let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    if (!this.state.edit_department_name) {
      formIsValid = false;
      errors["edit_department_name"] = "*Please enter your department name.";
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  handleChange = (event) => {
    this.setState({ errors: "" });
    let fields = this.state.fields;
    fields[event.target.name] = event.target.value;
    this.setState(
      {
        fields,
      },
      () => this.validateForm()
    );
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  // description logic here
  // Handle adding a new description field
  addDescription = () => {
    this.setState((prevState) => ({
      descriptions: [
        ...prevState.descriptions,
        { value: "", visibility: 1 }, // Add a new description with default visibility
      ],
    }));
  };

  // Handle removing a specific description field
  removeDescription = (index) => {
    this.setState((prevState) => {
      const updatedDescriptions = [...prevState.descriptions];
      updatedDescriptions.splice(index, 1); // Remove the description at the given index
      return { descriptions: updatedDescriptions };
    });
  };

  // Handle toggling visibility of a description
  toggleVisibility = (index) => {
    this.setState((prevState) => {
      const updatedDescriptions = [...prevState.descriptions];
      updatedDescriptions[index].visibility =
        updatedDescriptions[index].visibility === 1 ? 0 : 1;
      return { descriptions: updatedDescriptions };
    });
  };

  // Handle updating the value of a description field
  handleDescriptionChange = (index, value, key) => {
    this.setState((prevState) => {
      const updatedDescriptions = [...prevState.descriptions];
      updatedDescriptions[index].value = value;
      updatedDescriptions[index].key = key;
      return { descriptions: updatedDescriptions };
    });
  };
  generateRandomText(length = 16) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }

    return result;
  }

  toggleStatus = (index) => {
    this.setState((prevState) => {
      const newStatusList = [...prevState.status_list];
      newStatusList[index].visibility =
        newStatusList[index].visibility === 1 ? 0 : 1;
      return { status_list: newStatusList };
    });
  };
  onFileChange(file, type) {
    if (type == "edit_department_image") {
      this.setState({
        edit_department_image: file[0],
      });
    } else if (type == "edit_department_image_hover") {
      this.setState({
        edit_department_image_hover: file[0],
      });
    }
  }
  onBannerFileChange(file) {
    this.setState({
      edit_department_banner_image: file[0],
    });
  }

  // Handle package selection
  handlePackagesChange = (event) => {
    const selectedId = parseInt(event.target.value, 10);
    this.setState((prevState) => {
      const isSelected = prevState.selectedPackageId.includes(selectedId);

      // Add or remove the selected package ID
      const updatedSelectedPackages = isSelected
        ? prevState.selectedPackageId.filter((id) => id !== selectedId)
        : [...prevState.selectedPackageId, selectedId];

      return { selectedPackageId: updatedSelectedPackages };
    });
  };
  // Handle package selection
  handleInvestigationChange = (event) => {
    const selectedId = parseInt(event.target.value, 10);
    this.setState((prevState) => {
      const isSelected = prevState.selectedInvestigationId.includes(selectedId);

      // Add or remove the selected package ID
      const updatedSelectedPackages = isSelected
        ? prevState.selectedInvestigationId.filter((id) => id !== selectedId)
        : [...prevState.selectedInvestigationId, selectedId];

      return { selectedInvestigationId: updatedSelectedPackages };
    });
  };

  handleSelectionChange = (type, id) => {
    this.setState((prevState) => {
      const isSelected = prevState[type].includes(id);
      return {
        [type]: isSelected
          ? prevState[type].filter((item) => item !== id)
          : [...prevState[type], id],
      };
    });
  };

  handleSearchChange = (searchField, value) => {
    this.setState({ [searchField]: value });
  };

  renderSearchableDropdown = (label, type, items, selectedIds, searchField) => {
    const searchValue = this.state[searchField] || ""; // Retrieve the correct search value
    const filteredItems = items.filter((item) =>
      (item.name || item.Product_Name || "")
        .toLowerCase()
        .includes(searchValue.toLowerCase())
    );

    return (
      <div className="col-sm-6">
        <div className="form-group">
          <label>{label}</label>
          <input
            type="text"
            className="form-control mb-2"
            placeholder={`Search ${type}`}
            value={searchValue}
            onChange={(e) =>
              this.handleSearchChange(searchField, e.target.value)
            }
          />
          <div
            style={{
              border: "1px solid #ced4da",
              borderRadius: "4px",
              padding: "10px",
              maxHeight: "200px",
              overflowY: "scroll",
            }}
          >
            {filteredItems.length > 0 ? (
              filteredItems.map((item) => (
                <div
                  key={item.id}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(item.id)}
                    onChange={() => this.handleSelectionChange(type, item.id)}
                    style={{ marginRight: "10px" }}
                  />
                  <span>{item.name || item.Product_Name}</span>
                </div>
              ))
            ) : (
              <p>No {type} found</p>
            )}
          </div>
        </div>
      </div>
    );
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.validateForm() === true) {
      /*let fields = {};
            fields["edit_department_name"] = "";
            this.setState({ fields: fields });*/
      const id = this.state.department_id;
      const data = {
        edit_department_name: this.state.edit_department_name,
      };
      updateDepartment(
        id,
        data,
        this.state.edit_department_image,
        this.state.edit_department_image_hover,
        this.state.edit_department_banner_image,
        this.state.selectedPackageId,
        this.state.selectedInvestigationId,
        this.state.descriptions
      )
        .then((res) => {
          toast.success(res.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(function () {
            window.location.href = "/departments";
          }, 6000);
        })
        .catch((err) => {
          toast.error("Error occured", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        });
    } else {
      toast.error("Please provide department name!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };
  // Enable editing for a specific sl_no
  enableEditSlNo = (index, sl_no) => {
    this.setState({ editingSlNoIndex: index, updatedSlNo: sl_no });
  };

  // Handle the sl_no change
  handleSlNoChange = (event) => {
    this.setState({ updatedSlNo: event.target.value });
  };

  // Save the updated sl_no
  saveSlNo = (id) => {
    const { updatedSlNo, department_id, assignedDoctors } = this.state;
    const data = { sl_no: updatedSlNo };

    scAxiosAdmin
      .put(`/doctor_dept_rel/${id}`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(API_TOKEN_NAME)}`,
        },
      })
      .then((res) => {
        toast.success("SL No. updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        // Update the state immediately without fetching the data again
        const updatedDoctors = assignedDoctors.map((doctor) =>
          doctor.id === id ? { ...doctor, sl_no: updatedSlNo } : doctor
        );
        this.setState({
          assignedDoctors: updatedDoctors,
          editingSlNoIndex: null,
          updatedSlNo: "",
        });
      })
      .catch((err) => {
        toast.error("Error updating SL No.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        console.error(err);
      });
  };

  // Cancel the edit mode
  cancelEdit = () => {
    this.setState({ editingSlNoIndex: null, updatedSlNo: "" });
  };

  refreshgetSingleDepartmentData = (id) => {
    getSingleDepartmentData(id)
      .then((res) => {
        if (res.status === true) {
          var records = res.data;
          getAssignedDoctors(records.id)
            .then((res) => {
              if (res.status === 200) {
                var records = res.data;

                this.setState({
                  assignedDoctors: records,
                });
              } else {
                this.setState({
                  assignedDoctors: [],
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
          this.setState({
            department_id: records.id,
            edit_department_name: records.department_name,
            edit_department_id: records.dept_id,
            edit_department_image: records.image,
            edit_department_image_hover: records.image_hover,
            edit_department_banner_image: records.banner_image,
            descriptions: JSON.parse(records.description_list) || [
              { value: "", visibility: 1, key: this.generateRandomText() },
            ],
            selectedPackageId: records.packages || [],
            selectedInvestigationId: records.investigations || [],
          });
        } else {
          this.setState({
            department_id: "",
            edit_department_name: "",
            edit_department_id: "",
            edit_department_image: "",
            edit_department_image_hover: "",
            edit_department_banner_image: "",
            descriptions: [
              { value: "", visibility: 1, key: this.generateRandomText() },
            ],
            selectedPackageId: [],
            selectedInvestigationId: [],
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  refreshgetAllDepartmentData = () => {
    getAllPackages()
      .then((res) => {
        if (res.status === true) {
          var records = res.data;
          this.setState({
            packages: records,
          });
        } else {
          this.setState({
            packages: [],
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  refreshgetAllInvestigationData = () => {
    getInvestigations()
      .then((res) => {
        if (res.status === 200) {
          var records = res.data;
          this.setState({
            investigations: records,
          });
        } else {
          this.setState({
            investigations: [],
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  componentDidMount() {
    this.refreshgetSingleDepartmentData(this.props.match.params.id);
    this.refreshgetAllDepartmentData();
    this.refreshgetAllInvestigationData();
  }
  render() {
    const { assignedDoctors, editingSlNoIndex, updatedSlNo } = this.state;
    return (
      <div className="fixed-left">
        <div id="wrapper">
          <Route component={LeftSidebar} />
          <div className="content-page">
            <div className="content">
              <Route component={TopHeader} />
              <div className="page-content-wrapper">
                <div className="col-lg-12">
                  <div className="card m-b-20">
                    <div className="card-body">
                      <h4 className="mt-0 header-title">Edit Department</h4>

                      <form
                        onSubmit={this.handleSubmit}
                        id="editdepartmentform"
                        className="needs-validation"
                        noValidate
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Department Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="edit_department_name"
                                id="edit_department_name"
                                value={this.state.edit_department_name}
                                onChange={this.handleChange}
                                required
                                placeholder="Department Name"
                              />
                              <span style={alertStyle}>
                                {this.state.errors.edit_department_name}
                              </span>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Department Id</label>
                              <input
                                type="text"
                                className="form-control"
                                name="edit_department_id"
                                id="edit_department_id"
                                value={this.state.edit_department_id}
                                onChange={this.handleChange}
                                required
                                placeholder="Department Id"
                                readOnly
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row mb-3">
                          {this.renderSearchableDropdown(
                            "Select Packages",
                            "selectedPackageId",
                            this.state.packages,
                            this.state.selectedPackageId,
                            "packageSearch"
                          )}
                          {this.renderSearchableDropdown(
                            "Select Investigations",
                            "selectedInvestigationId",
                            this.state.investigations,
                            this.state.selectedInvestigationId,
                            "investigationSearch"
                          )}
                        </div>

                        <div>
                          <h4>Add Department Descriptions</h4>
                          {this.state.descriptions
                            ? this.state.descriptions.map((desc, index) => (
                                <div key={index} className="row mb-2">
                                  <div className="col-sm-12">
                                    <div className="form-group">
                                      <label>{`Description ${
                                        index + 1
                                      }`}</label>
                                      <NewReachTextEditor
                                        id={`Description-${index + 1}`}
                                        name={`Description-${index + 1}`}
                                        value={desc.value}
                                        onChange={(name, val) =>
                                          this.handleDescriptionChange(
                                            index,
                                            val,
                                            this.generateRandomText()
                                          )
                                        }
                                      />
                                      <div className="d-flex justify-content-between align-items-center">
                                        <button
                                          type="button"
                                          onClick={() =>
                                            this.toggleVisibility(index)
                                          }
                                          className={`btn ${
                                            desc.visibility === 1
                                              ? "btn-success"
                                              : "btn-danger"
                                          } mt-2`}
                                        >
                                          {desc.visibility === 1
                                            ? "Hide"
                                            : "Show"}
                                        </button>
                                        {index > 0 && (
                                          <button
                                            type="button"
                                            onClick={() =>
                                              this.removeDescription(index)
                                            }
                                            className="btn btn-danger ml-2 mt-2"
                                          >
                                            Remove
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            : ""}
                          <button
                            type="button"
                            onClick={this.addDescription}
                            className="btn btn-primary mb-3"
                          >
                            Add Description
                          </button>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Department Icon</label>
                              <div className="department_icon_show_img_sec mb-2">
                                <img
                                  src={
                                    IMAGE_URL +
                                    "/DepartmentImage/" +
                                    this.state.edit_department_image
                                  }
                                  alt=""
                                  width="130px"
                                />
                              </div>
                              <input
                                type="file"
                                className="form-control"
                                name="edit_department_image"
                                id="edit_department_image"
                                onChange={(event) =>
                                  this.onFileChange(
                                    event.target.files,
                                    "edit_department_image"
                                  )
                                }
                                accept="jpg,png"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Department Hover Icon</label>
                              <div className="department_icon_show_img_sec mb-2">
                                <img
                                  src={
                                    IMAGE_URL +
                                    "/DepartmentImage/" +
                                    this.state.edit_department_image_hover
                                  }
                                  alt=""
                                  width="130px"
                                />
                              </div>
                              <input
                                type="file"
                                className="form-control"
                                name="edit_department_image_hover"
                                id="edit_department_image_hover"
                                onChange={(event) =>
                                  this.onFileChange(
                                    event.target.files,
                                    "edit_department_image_hover"
                                  )
                                }
                                accept="jpg,png"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Department Banner Image</label>
                              <div className="department_banner_show_img_sec mb-2">
                                <img
                                  src={
                                    IMAGE_URL +
                                    "/DepartmentImage/" +
                                    this.state.edit_department_banner_image
                                  }
                                  alt=""
                                  width="130px"
                                />
                              </div>
                              <input
                                type="file"
                                className="form-control"
                                name="edit_department_banner_image"
                                id="edit_department_banner_image"
                                onChange={(event) =>
                                  this.onBannerFileChange(event.target.files)
                                }
                                accept="jpg,png"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div>
                            <button
                              type="submit"
                              className="btn btn-pink waves-effect waves-light"
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      </form>
                      <hr className="w-75 mx-auto my-5" />
                      <div className="">
                        <h4>Update Assigned doctors serial</h4>
                        <table className="table table-bordered table-striped table-hover">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Doctor Name</th>
                              <th>Sl No</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {assignedDoctors.length > 0
                              ? assignedDoctors.map((doctor, index) =>
                                  doctor.doctor_mave ? (
                                    <tr key={doctor.id}>
                                      <td>{index + 1}</td>
                                      {/* {console.log(
                                      "your log output",
                                      doctor
                                    )} */}
                                      <td>
                                        {doctor.doctor_mave
                                          ? doctor.doctor_mave.doctor_name
                                          : ""}
                                      </td>
                                      <td>
                                        {editingSlNoIndex === index ? (
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={updatedSlNo}
                                            onChange={this.handleSlNoChange}
                                            required
                                          />
                                        ) : (
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              updatedSlNo
                                                ? updatedSlNo
                                                : doctor.sl_no
                                            }
                                            readOnly
                                          />
                                        )}
                                      </td>
                                      <td>
                                        {editingSlNoIndex === index ? (
                                          <div className="d-flex justify-content-start align-items-center gap-2">
                                            <button
                                              className="btn btn-success"
                                              onClick={() =>
                                                this.saveSlNo(doctor.id)
                                              }
                                            >
                                              Save
                                            </button>
                                            <button
                                              className="btn btn-danger ml-2"
                                              onClick={this.cancelEdit}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        ) : (
                                          <button
                                            className="btn btn-primary"
                                            onClick={() =>
                                              this.enableEditSlNo(
                                                index,
                                                doctor.sl_no
                                              )
                                            }
                                          >
                                            Update
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )
                                )
                              : ""}
                          </tbody>
                        </table>
                        <ToastContainer autoClose={5000} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer autoClose={5000} />
      </div>
    );
  }
}
export default EditDepartment;



// WEBPACK FOOTER //
// ./src/component/admin/editdepartment.js